export default __webpack_public_path__ + "static/media/marimba_drop.6e8f968c.wav";